// OrderSummary.jsx
import React from "react";

const OrderSummary = ({ subscriptionData }) => {
  //  Calculation of Price
  const base_Price = subscriptionData?.price; // Base price of the subscription plan
  const plan_Duration = subscriptionData.duration; // Duration of the subscription plan
  const base_gst = 18; // GST rate in percentage

  // Calculate the total price for the given duration
  const total_Price_Before_Gst = base_Price * plan_Duration;

  // Calculate the GST amount
  const plan_Gst = (total_Price_Before_Gst * base_gst) / 100;

  // Calculate the final total price including GST
  const total_Price = total_Price_Before_Gst + plan_Gst;

  //Stipe Integer Pricing

  const strip_Price = total_Price * 100;

  console.log("Total Price Including Gst:", total_Price);

  // End
  const monthlyprice = 30; // Ensure price is a number
  const freeMonths = parseInt(subscriptionData?.freeMonths);
  return (
    <div className="px-4 pt-8 order-1">
      <div className="sticky top-5 p-6 bg-white rounded-lg shadow-lg">
        <h5 className="text-xl font-bold mb-6 border-b">Order Summary</h5>

        <div className="space-y-4">
          <div className="flex justify-between border-b pb-4 mb-4">
            <div className="flex flex-col">
              <p className="font-semibold text-lg">
                {plan_Duration} Months Plan ({subscriptionData.title})
              </p>
              <p className="text-purple-600 text-sm">
                Save {subscriptionData?.savings}%
              </p>
            </div>
            <div className="flex flex-col items-end">
              <p className="line-through text-gray-500">
                ${total_Price_Before_Gst * plan_Duration}
              </p>
              <p className="text-purple-600 text-xl font-semibold">
                ${total_Price_Before_Gst}
              </p>
            </div>
          </div>

          <div className="flex justify-between border-b pb-4 mb-4">
            <div className="flex flex-col">
              <p className="font-semibold text-lg">+ 2 Months FREE</p>
              <p className="text-gray-500 text-sm">SPECIALDEAL</p>
            </div>
            <div className="flex flex-col items-end">
              <p className="line-through text-gray-500">
                ${monthlyprice * freeMonths}
              </p>
              <p className="text-gray-500 text-xl font-semibold">$0.00</p>
            </div>
          </div>

          <div className="flex justify-between border-b pb-4 mb-4">
            <div className="flex flex-col">
              <p className="font-semibold text-lg">Tax</p>
            </div>
            <div className="flex flex-col items-end">
              <p className="text-gray-500 text-xl font-semibold">${plan_Gst}</p>
            </div>
          </div>
        </div>

        <div className="flex justify-between border-b pb-4 mb-4">
          <h5 className="text-xl font-bold">Order Total</h5>
          <p className="text-purple-600 text-xl font-semibold">
            ${total_Price}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
